// extracted by mini-css-extract-plugin
export default {"container":"Statistics_container__wTvAI","content":"Statistics_content__RDdRi","table":"Statistics_table__WfSp1","dashboard":"Statistics_dashboard__F38Zw"};